import React from "react";
import { useSelector } from "react-redux";
import RegistrationsOnboarding from "./onboarding/RegistrationsOnboarding";
import RegistrationsPrincipal from "./principal/RegistrationsPrincipal";
import RegistrationsBilling from "./billing/RegistrationsBilling";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";

const Registrations = () => {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_principal) {
      return <RegistrationsPrincipal />;
    }
    if (state.auth.user.is_billing) {
      return <RegistrationsBilling />;
    }
    if (state.auth.user.is_onboarding) {
      return <RegistrationsOnboarding />;
    }
    return <PermissionDenied />;
  }
};

export default Registrations;
